import type {CatalogEntry} from "./catalogTypes";

export type Program = CatalogEntry;

export const programs: Program[] = [
  {
    slug: "calendar-evenimente",
    sortDate: "2027-02-21",
    image: "/assets/ateliere/calendar-evenimente-octombrie-februarie-2026.jpeg",
    previewImage: "/assets/ateliere/calendar-evenimente-octombrie-februarie-2026-preview.1c084059.webp",
    imageAlt: "Calendarul evenimentelor Personocrația din octombrie 2026 până în februarie 2027",
  },
  {
    slug: "personocratia-noiembrie-2026",
    sortDate: "2026-11-19",
    image: "/assets/ateliere/personocratia-19-22-noiembrie-2026.jpeg",
    previewImage: "/assets/ateliere/personocratia-19-22-noiembrie-2026-preview.9c9e3236.webp",
    imageAlt: "Afișul atelierului Personocrația din 19–22 noiembrie",
  },
  {
    slug: "povestea-ta",
    // eyebrow: "COPII 7+ · TABĂRĂ",
    // title: "Povestea Ta",
    // description: "Tabere sezoniere cu joc, poveste și creație.",
    // mobileDescription: "Tabere sezoniere cu joc și creație.",
    // featuredDescription: "Joc, creație și explorare în ritmul copiilor.",
    // featuredMobileDescription: "Joc, creație și descoperire.",
    // status: "28 oct – 1 nov 2026",
    sortDate: "2026-10-28",
    image: "/assets/ateliere/kids-invitation.png",
    previewImage: "/assets/ateliere/kids-invitation-preview.e6b9c996.webp",
    imageAlt: "Afișul taberei de toamnă Povestea Ta pentru copii",
    // imagePosition: "center bottom",
    // details: "Tabără pentru copii de la 7 ani, cu activități creative, joc și explorare în natură. Ediția de toamnă este anunțată pentru 28 octombrie – 1 noiembrie 2026. Pentru programul complet și înscriere, contactează asociația.",
  },
  {
    slug: "limbajul-chipului",
    sortDate: "2026-08-01",
    image: "/assets/ateliere/adult-intensive.png",
    previewImage: "/assets/ateliere/adult-intensive-preview.ed03dda9.webp",
    imageAlt: "Afișul atelierului Limbajul chipului cu Laura Eli și Andrei",
  },
  {
    slug: "5r",
    sortDate: "2026-08-01",
    image: "/assets/ateliere/five-r.png",
    previewImage: "/assets/ateliere/five-r-preview.09954dd2.webp",
    imageAlt: "Afișul programului 5R al asociației",
  },
];

programs.sort((a, b) => (b.sortDate || "").localeCompare(a.sortDate || ""));

export const featuredPrograms = ["calendar-evenimente", "personocratia-noiembrie-2026", "povestea-ta"]
  .map(slug => programs.find(program => program.slug === slug))
  .filter((program): program is Program => Boolean(program));
